const styles = {
  alert: {
    minWidth: 400,
    minHeight: 80,
    paddingBlock: theme => theme.spacing(2),
    marginTop: theme => theme.spacing(3),
    marginBottom: theme => theme.spacing(3),
    '&.MuiAlert-root': {
      alignItems: 'baseline',
    },
    '&.MuiAlert-root .MuiLink-root': {
      margin: 0,
      color: theme => theme.palette.primary.main,
      fontSize: 14,
      fontFamily: 'ActoMedium',
      fontWeight: 500,
      lineHeight: theme => theme.spacing(2.275),
      '&::after': {
        backgroundColor: theme => theme.palette.primary.main,
      },
      '& ~ svg': {
        marginLeft: theme => theme.spacing(0.5),
      },
    },
  },
  alertTitle: {
    '&.MuiTypography-root': {
      marginBottom: theme => theme.spacing(1),
    },
  },
}

export default styles
